import React from 'react'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
import StepIcon from '../../components/stepIcon'
import BigLogo from '../../assets/imgs/logoBigX.png'
import {
  BackgroundContainer,
  BodyContainer,
  SvgArrowIcon,
  Header,
  StageContainer,
  StepsContainer,
  StepsIconsContainer,
  SvgLogo, Wrapper,
  SvgWarning,
} from './styles'
import Modal from '../../components/modal'

type Props={
  isThirdStep:boolean
  stepsIconsFill:Array<string>
  arrowsfill:Array<string>
  pages:Array<any>
  step:number
  startModal:boolean
  setStartModal:any
  tawkRef:any
}
const Home = ({
  tawkRef,
  isThirdStep,
  stepsIconsFill,
  arrowsfill,
  pages,
  step,
  startModal,
  setStartModal,
}:Props) => (
  <Wrapper>
    {startModal && (
      <Modal
        className="startModal"
        closeModal={() => setStartModal(false)}
        inputs={(
          <div className="startModalContainer">
            {' '}
            <h1>
              Wexer Cotação de Testes
            </h1>
            <SvgWarning />

            <p>
              Esta ferramenta foi desenvolvida para auxiliar os profissionais de psicologia
              a consultarem de forma mais ágil a tabela de resultado dos testes.
            </p>
            <p>
              <p>
                Atenção:
              </p>
              <p>
                • O uso desta ferramenta não substitui a leitura do manual do teste.

              </p>
              <p>
                • Qualquer informação divergente entre a ferramenta e o manual do teste,
                deve ser considerada a informação constante no manual.

              </p>
            </p>

          </div>
      )}
      />
    )}
    <TawkMessengerReact
      propertyId="62a89311b0d10b6f3e774d0f"
      widgetId="1g5h7svj5"
      useRef={tawkRef}
    />
    <BackgroundContainer url={BigLogo} />
    <Header>
      <SvgLogo />
    </Header>
    <BodyContainer>
      <StepsIconsContainer>
        <StageContainer>
          <StepIcon stepNumber={1} stepfill={stepsIconsFill[0]} />
        </StageContainer>
        <span className="arrowsPlace">
          <SvgArrowIcon arrowfill={arrowsfill[0]} />
        </span>
        <StageContainer>
          <StepIcon stepNumber={2} stepfill={stepsIconsFill[1]} />
        </StageContainer>
        <span className="arrowsPlace">
          <SvgArrowIcon arrowfill={arrowsfill[1]} />
        </span>
        <StageContainer>
          <StepIcon stepNumber={3} stepfill={stepsIconsFill[2]} />
        </StageContainer>
      </StepsIconsContainer>
      <StepsContainer
        isThirdStep={isThirdStep}
      >
        {pages[step]}
      </StepsContainer>
    </BodyContainer>
  </Wrapper>
)
export default Home
